/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetricCategory } from './MetricCategory';
import {
    MetricCategoryFromJSON,
    MetricCategoryFromJSONTyped,
    MetricCategoryToJSON,
    MetricCategoryToJSONTyped,
} from './MetricCategory';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface CreateMetricRequest
 */
export interface CreateMetricRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMetricRequest
     */
    name: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateMetricRequest
     */
    sourceUnit?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMetricRequest
     */
    lc: Array<string>;
    /**
     * 
     * @type {MetricCategory}
     * @memberof CreateMetricRequest
     */
    category: MetricCategory;
    /**
     * 
     * @type {Resolution}
     * @memberof CreateMetricRequest
     */
    resolution?: Resolution;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMetricRequest
     */
    licenseFeatures?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateMetricRequest
     */
    rawMetricKey: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMetricRequest
     */
    dataProviderKey: string;
    /**
     * Minimum value filter
     * @type {number}
     * @memberof CreateMetricRequest
     */
    min?: number;
    /**
     * Maximum value filter
     * @type {number}
     * @memberof CreateMetricRequest
     */
    max?: number;
}



/**
 * Check if a given object implements the CreateMetricRequest interface.
 */
export function instanceOfCreateMetricRequest(value: object): value is CreateMetricRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('lc' in value) || value['lc'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('rawMetricKey' in value) || value['rawMetricKey'] === undefined) return false;
    if (!('dataProviderKey' in value) || value['dataProviderKey'] === undefined) return false;
    return true;
}

export function CreateMetricRequestFromJSON(json: any): CreateMetricRequest {
    return CreateMetricRequestFromJSONTyped(json, false);
}

export function CreateMetricRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMetricRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'sourceUnit': json['sourceUnit'] == null ? undefined : json['sourceUnit'],
        'lc': json['lc'],
        'category': MetricCategoryFromJSON(json['category']),
        'resolution': json['resolution'] == null ? undefined : ResolutionFromJSON(json['resolution']),
        'licenseFeatures': json['licenseFeatures'] == null ? undefined : json['licenseFeatures'],
        'rawMetricKey': json['rawMetricKey'],
        'dataProviderKey': json['dataProviderKey'],
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function CreateMetricRequestToJSON(json: any): CreateMetricRequest {
    return CreateMetricRequestToJSONTyped(json, false);
}

export function CreateMetricRequestToJSONTyped(value?: CreateMetricRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'sourceUnit': value['sourceUnit'],
        'lc': value['lc'],
        'category': MetricCategoryToJSON(value['category']),
        'resolution': ResolutionToJSON(value['resolution']),
        'licenseFeatures': value['licenseFeatures'],
        'rawMetricKey': value['rawMetricKey'],
        'dataProviderKey': value['dataProviderKey'],
        'min': value['min'],
        'max': value['max'],
    };
}

